"use client";

import { c as _c } from "react/compiler-runtime";
import { assign } from "es-toolkit/compat";
import { motion } from "motion/react";
import { useCallbackRef, useDimensions } from "../../hooks";
import { Block } from "../Block";
export function AnimateHeight(t0) {
  const $ = _c(18);
  let animate;
  let children;
  let className;
  let rest;
  if ($[0] !== t0) {
    ({
      children,
      className,
      animate,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = animate;
    $[2] = children;
    $[3] = className;
    $[4] = rest;
  } else {
    animate = $[1];
    children = $[2];
    className = $[3];
    rest = $[4];
  }
  const [childRef, setChildRef] = useCallbackRef();
  const {
    height: childHeight
  } = useDimensions(childRef);
  let t1;
  if ($[5] !== animate || $[6] !== childHeight || $[7] !== childRef.current) {
    t1 = childRef.current ? assign({
      height: childHeight
    }, typeof animate === "object" ? animate : {}) : undefined;
    $[5] = animate;
    $[6] = childHeight;
    $[7] = childRef.current;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  let t2;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      type: "spring",
      bounce: 0,
      duration: 0.3
    };
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  let t3;
  if ($[10] !== children || $[11] !== setChildRef) {
    t3 = <Block asChild={true} ref={setChildRef}>{children}</Block>;
    $[10] = children;
    $[11] = setChildRef;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  let t4;
  if ($[13] !== className || $[14] !== rest || $[15] !== t1 || $[16] !== t3) {
    t4 = <motion.div animate={t1} className={className} initial={false} transition={t2} {...rest}>{t3}</motion.div>;
    $[13] = className;
    $[14] = rest;
    $[15] = t1;
    $[16] = t3;
    $[17] = t4;
  } else {
    t4 = $[17];
  }
  return t4;
}